import {
  CURRENT_ONBOARDING_VERSION,
  CURRENT_PRICING_PAGE_VERSION,
  ONBOARDING_FLAGS,
  OnboardingFlag,
} from '@contentlab/types/onBoardingFlags';
import useUpdateDashboardUser from '@/hooks/mutations/use-update-dashboard-user';
import useDashboardUserQuery from '@/hooks/queries/use-dashboard-user-query';

const onboardingVersionMap = {
  [ONBOARDING_FLAGS.HAS_COMPLETED_CURRENT_ONBOARDING_VERSION]:
    CURRENT_ONBOARDING_VERSION,
  [ONBOARDING_FLAGS.HAS_SEEN_CURRENT_PRICING_PAGE_VERSION]:
    CURRENT_PRICING_PAGE_VERSION,
};

function useSetOnboardingFlags(key: OnboardingFlag) {
  const {dashboardUser} = useDashboardUserQuery({});
  const dashboardUserMutation = useUpdateDashboardUser();

  const setOnboardingFlag = () => {
    if (dashboardUser?.id) {
      dashboardUserMutation.mutate({
        id: dashboardUser.id,
        [key]: onboardingVersionMap[key],
      });
    }
  };

  return setOnboardingFlag;
}

export default useSetOnboardingFlags;
